import * as React from 'react';
import { PdsIconShield as PdsIconShieldElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconShield = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-shield',
  elementClass: PdsIconShieldElement,
  react: React,
});
